import React, { useState, useEffect, useRef } from 'react';
import ExpenseTable from './ExpenseTable';
import CalendarDay from 'src/models/AP/CalendarDay';
import DayEntry from 'src/models/AP/DayEntry';
import UserExpense from 'src/models/AP/EmployeeExpense';
import { FiDelete, FiMail, FiDownloadCloud } from 'react-icons/fi';
import { HiOutlineClipboardCopy } from 'react-icons/hi';
import { FaDollarSign } from 'react-icons/fa';
import BillingSummary from 'src/models/AP/BillingSummary';
import { useForm } from 'react-hook-form';
import { useServiceCtx } from './TimeAndExpenseServiceContext';
import { AnyObject } from 'final-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';

interface IDayEntryProps {
  editMode?: boolean;
  editedDayEntry?: DayEntry;
  editedDayEntryIndex?: number;
  calendarDays?: Array<CalendarDay>;
  previousCalendarDays?: Array<CalendarDay>;
  dayEntry?: DayEntry;
  register: ReturnType<typeof useForm>['register'];
  setValue: ReturnType<typeof useForm>['setValue'];
  getValues: ReturnType<typeof useForm>['getValues'];
  previousBillingValues?: Array<DayEntry>;
  calendarDay?: CalendarDay;
  calendarDayIndex?: number;
  dayEntryIndex?: number;
  summaryIndex?: number;
  compType?: string;
  disableDayEntry?: boolean;
  adminToUser?: boolean;
  confirmedDeleteDayEntry?: boolean;
  tmidToDelete?: number;
  setTmIdToDelete?: (id: number) => void;
  payperiod?: string;
  selectedIndex?: number;
  setShowDeletWarning?: (show: object) => void;
  setExpenseEntered?: (expenseEntered: boolean) => void;  
  setShouldFocus?: (shouldFocus: boolean) => void;  
  editTimeline: (daysToEdit: Array<DayEntry>) => void;
  hasReceipts?: (value: boolean) => void;
  closeDialog?: (resetPage: boolean) => void;
  isValidDayEntry: (
    listener: boolean,
    calendarDayIndex: number,
    dayEntryIndex: number
  ) => void;
  updateDays?: (
    data: AnyObject,
    deleteId: number,
    calIndex: number,
    dayIndex: number
  ) => void;
}

const DayEntryComponent = ({
  register,
  previousBillingValues,
  editTimeline,
  selectedIndex,
  calendarDays,
  closeDialog,
  editMode,
  tmidToDelete,
  setValue,
  setShowDeletWarning,
  getValues,
  compType,
  calendarDay,
  calendarDayIndex,
  editedDayEntry,
  confirmedDeleteDayEntry,
  setTmIdToDelete,
  dayEntry,
  dayEntryIndex,
  disableDayEntry,
  isValidDayEntry,
  updateDays,
  adminToUser,
  payperiod,
  hasReceipts,

}: IDayEntryProps) => {
  const {
    getTEData,
    deleteReceipt,
    emailReceipt,
    getReceiptForExpense,
    deleteDayEntry,
    newReceiptInfo,
    adminGetUserInfo,
  } = useServiceCtx();
  const suppressClick = useRef(false);
  const dispatch = useDispatch();
  const [indvBtn, setIndvBtn] = useState('');
  const [prevWorkDesc, setPrevWorkDesc] = useState('');
  const [showValidation, setShowValidation] = useState(false);
  const [addUniqueExpense, setAddUniqueExpense] = useState(false);
  const [showContainer, setShowContainer] = useState(false);
  const [expenseDescript, setExpenseDescript] = useState('');
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [displayReceipts, setDisplayReceipts] = useState(false);
  const [expense, setExpense] = useState<UserExpense>({});
  const [esId, setEsId] = useState<number>(0);
  // const [receiptThumbnails, setReceiptThumbnails] = useState<Array<{ base64ReceiptString: string, fileName: string }>>(undefined);
  // const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!!dayEntry?.workDescription && dayEntry?.workDescription !== '') {
      setPrevWorkDesc(dayEntry?.workDescription!);
      setValue(`calendarDays.${calendarDayIndex}.dayEntries.${dayEntryIndex}.workDescription`, dayEntry?.workDescription!);
    }
    
    setShowDeleteBtn(true);
  }, []);

  useEffect(() => {
    if (
      !!displayReceipts &&
      !!expense?.receipts &&
      expense?.receipts!.length > 0
    ) {
      renderReceipts();
    }
  }, [displayReceipts, expense]);

  useEffect(() => {
    if (confirmedDeleteDayEntry && dayEntry?.tmId === tmidToDelete) {
      handleDeleteDay(dayEntry?.tmId);
    }
  }, [confirmedDeleteDayEntry]);

  const addExpense = (index: string) => {
    setTimeout(() => {
      if (suppressClick.current === false) {
        const wdValue = getValues(`calendarDays.${calendarDayIndex}.dayEntries.${dayEntryIndex}.workDescription`);
        if (!!validateWorkDescription(wdValue)) {
          setIndvBtn(index);
          setAddUniqueExpense(true);
          setShowContainer(true);
          setDisplayReceipts(false);
          setExpenseDescript('');
        }
      }
      suppressClick.current = false;
    }, 200);
  };

  const handleExpenseAdded = (signal: boolean) => {
    if (!!signal) {
      setIndvBtn('');
      setAddUniqueExpense(false);
    }
  };

  const validateWorkDescription = (val: string) => {
    const previousHours = editedDayEntry?.hours;
    const newHours = dayEntry?.hours;
    let hoursChanged = newHours !== undefined && newHours !== previousHours;
    if (editMode) {
      const formSummary: BillingSummary[] = getValues()?.summary;

      let tmidList: DayEntry[] = [];
      let previousDayEntry: DayEntry = previousBillingValues![selectedIndex!]; 
      for (let dayIndex = 1; dayIndex <= 16; dayIndex++) {        
        let hours = getValues(`summary.${selectedIndex!}.day${dayIndex}Hours`);
        if ( hours !== null && hours !== undefined && !isNaN(hours)) {
            let dayEntries = calendarDays![dayIndex - 1].dayEntries;
            let foundDayEntries = dayEntries.filter(
                (de: DayEntry) =>
                `${de.clientNumber}.${de.prospectNumber}.${
                    !!de.sectionNumber ? de.sectionNumber : 0
                }.${!!de.unitNumber ? de.unitNumber : 0}` === (`${previousDayEntry.clientNumber}.${previousDayEntry.prospectNumber}.${(previousDayEntry.sectionNumber === undefined || previousDayEntry.sectionNumber === null) ? 0 : previousDayEntry.sectionNumber}.${(previousDayEntry.unitNumber === undefined || previousDayEntry.unitNumber === null) ? 0 : previousDayEntry.unitNumber}`) 
                && (de.selectedAccountCodeContainer?.name === previousDayEntry?.selectedAccountCodeContainer!.name)
            );

            for (let localDayEntryIndex = 0; localDayEntryIndex < foundDayEntries.length; localDayEntryIndex++) {
                let tmId = foundDayEntries[localDayEntryIndex]?.tmId;
                let tmDate = foundDayEntries[localDayEntryIndex]?.tmDate;
                console.log('tmId: ' + tmId);
                if (tmId !== null && tmId !== undefined && !isNaN(tmId)) {
                    tmidList.push({
                        workDescription: foundDayEntries[localDayEntryIndex]?.workDescription,
                        tmId: tmId,
                        tmDate: tmDate,
                        prospectNumber: formSummary[selectedIndex!].prospectNumber!,
                        clientNumber: formSummary[selectedIndex!].clientNumber!,
                        sectionNumber: formSummary[selectedIndex!].sectionNumber!,
                        unitNumber: formSummary[selectedIndex!].unitNumber!,
                        selectedAccountCodeContainer: previousDayEntry?.selectedAccountCodeContainer,
                        hours: compType === 'D' ? 8 * hours : hours
                    });
                } 
            }
        }        
      }

      editTimeline(tmidList);

     } else if (val === '') {
      setShowValidation(true);
      return false;
    } else if (val === prevWorkDesc && !hoursChanged) {
      console.log(
        'the content is the same as the prev content, no calls needed'
      );
    } else {
      isValidDayEntry(true, calendarDayIndex!, dayEntryIndex!);
      setPrevWorkDesc(val);
      setShowDeleteBtn(true);
    }
    return true;
  };

  const newReceiptData = (expId: number, tsdiNumber?: number) => {
    if (!adminToUser) {
      getTEData!(false)
        .then((val: { calendarDays: Array<CalendarDay>}) => {
          let uniqueDayEntry =
            val?.calendarDays[calendarDayIndex!].dayEntries[dayEntryIndex!];

          let uniqueExpense = uniqueDayEntry?.userExpenses?.find(
            (ue: UserExpense) => ue.esId === expId
          );
          if (!!uniqueExpense?.receipts) {
            setDisplayReceipts(true);
            hasReceipts?.(true);
            setExpense(uniqueExpense);
            setExpenseDescript(uniqueExpense?.description);
          } else {
            setDisplayReceipts(false);
            setExpense(uniqueExpense);
          }
        })
        .catch((e: unknown) => {
          console.log('error occured while trying to get the new data, ', e);
        });
    } else {
      if (!!payperiod && !!tsdiNumber) {
        let id = `${tsdiNumber}`;
        adminGetUserInfo!(payperiod, id)
          .then((val: { calendarDays: Array<CalendarDay>}) => {
            let uniqueDayEntry =
              val?.calendarDays[calendarDayIndex!].dayEntries[dayEntryIndex!];

            let uniqueExpense = uniqueDayEntry?.userExpenses?.find(
              (ue: UserExpense) => ue.esId === expId
            );
            if (!!uniqueExpense?.receipts) {
              setDisplayReceipts(true);
              hasReceipts?.(true);
              setExpense(uniqueExpense);
              setExpenseDescript(uniqueExpense?.description);
            } else {
              setDisplayReceipts(false);
              setExpense(uniqueExpense);
            }
          })
          .catch((e: unknown) => {
            console.log('error occured while trying to get the new data, ', e);
          });
      }
    }
  };

  const handleDisplayReceipts = (
    flag: boolean,
    expId?: number,
    tsdiNumber?: number
  ) => {
    setDisplayReceipts(false);
    setExpenseDescript('');

    if (!!flag && !!tsdiNumber) {
      newReceiptData(expId!, tsdiNumber!);
      setEsId(expId!);
    } else {
      newReceiptData(expId!, undefined);
      setEsId(expId!);
    }
  };

  const renderReceipts = () => {
    return (
      <div>
        <div className="tw-mt-2 tw-p-4 tw-w-full">
          {expense.receipts?.map((r, index) => {
            let expRecId = r.expenseRecordId;
            return (
              <div
                key={index}
                className="tw-flex tw-justify-between tw-items-center tw-gap-4 tw-border-2 tw-border-green-200 tw-rounded tw-mb-2"
              >
                <Button
                  toolTip={'Download Receipt'}
                  reactIcon={FiDownloadCloud}
                  onClick={() => handleDownloadReceipt(expRecId)}
                />
                <FiMail
                    data-tooltip-id="expense-tooltip"
                    data-tooltip-content={`Email ` + r.fileName + ` to your registered email address.`}
                    data-tooltip-place="left"
                    data-tooltip-position-strategy="absolute"
                    data-tooltip-delay-show={500}
                    onClick={() => handleEmailReceipt(expRecId)}
                />
                <p
                    className="tw-ml-2"
                >
                    {r.fileName}
                </p>
                {!disableDayEntry && (
                  <div
                    onClick={() => handleDeleteReceipt(expRecId, expense?.receipts?.length)}
                    className="tw-bg-red-500 tw-text-white tw-flex tw-justify-center tw-items-center tw-w-[30px] tw-h-[30px] tw-rounded tw-hover:tw-bg-red-800 tw-active:tw-bg-red-300 tw-cursor-pointer"
                  >
                    <span className="tw-p-4">
                      <FiDelete />
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleEmailReceipt = (receiptId: number) => {
    emailReceipt!(receiptId)
      .then((val: number) => {
      if (val === 200) {
        console.log('Receipt email succeeded');
      }
    })
    .catch();
  };

  const handleDownloadReceipt = (receiptId: number) => {
    getReceiptForExpense!(receiptId)
      .then((val: Blob) => {
        if (val instanceof Blob) {
        console.log('Receipt download succeeded');
      }
    })
    .catch();
  };

  const displayDeleteWarning = () => {
    setTmIdToDelete(dayEntry?.tmId);
    dispatch(actions.layout.hideDialog());
    setShowDeletWarning(new Object());
  };

  const handleDeleteReceipt = (id: number, receiptCount?: number) => {
    setDisplayReceipts(false);
    deleteReceipt!(id)
      .then((val: number) => {
        if (val === 201) {
          let newReceiptCount = receiptCount! - 1;
          newReceiptData(esId, dayEntry?.tsdNo);
          newReceiptInfo!({
            id: id,
            desc: expenseDescript,
            count: newReceiptCount,
            calendarDayIndex: calendarDayIndex,
          });

          let expensesIndex = dayEntry?.userExpenses?.findIndex(
            (ue: UserExpense) => ue.esId === esId
          );
          let filteredExpenses = dayEntry?.userExpenses![
            expensesIndex!
          ]?.receipts?.filter((r) => r?.expenseRecordId !== id);

          dayEntry!.userExpenses![expensesIndex!].receipts = filteredExpenses;
        }
      })
      .catch();
  };

  const handleShowContainer = (flag: boolean) => {
    setShowContainer(flag);
  };

  const handleDeleteDay = (id: number) => {
    if (tmidToDelete === id) {
      setTmIdToDelete(undefined);
      deleteDayEntry!(id)
        .then((val: number | void | AnyObject) => {
          if (val === 200) {
            getTEData!(false)
              .then((val2: AnyObject) => {
                updateDays!(val2, id, calendarDayIndex!, dayEntryIndex!);
              })
              .catch((e: unknown) => {
                console.log('what is the error on this, ', e);
              });
          }
        })
        .catch((e: unknown) => {
          console.log('what is the error on this, ', e);
        }).then(() => {
          // Do nothing currently.
          // closeDialog!(true);
        });
    }
  };

  const copyDescription = async () => {
    try {
      await navigator.clipboard.writeText(prevWorkDesc);
    } catch (err) {
      console.log('Failed to copy: ', err);
    }
  };

  const showDialog = (dialog: DialogList) => {
    dispatch(actions.layout.showDialog(dialog));
  };

  const showReceiptViewerDialog = () => {
    showDialog(DialogList.RECEIPT_VIEWER);
  };

  const loadAndViewReceiptThumbnails = () => {
    // Load everything needed to open the ReceiptViewer dialog
    // Then show the dialog
    showReceiptViewerDialog();
  };

  const renderExpenses = () => {
    return (
      dayEntry?.userExpenses?.length! > 0 &&
      dayEntry?.userExpenses?.map((ue) => {
        return (
          <div
            key={`${dayEntryIndex}-${ue.code}`}
            className="tw-flex tw-items-center"
          >
            {ue?.code === 'O' ? (
              <div className=" tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-w-[175px] tw-p-2 tw-text-center tw-border-gray-300 tw-font-semibold tw-flex tw-items-center tw-justify-center">
                <p>{ue.otherDescription}</p>
              </div>
            ) : ue?.code === 'L' ? (
              <div className=" tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-w-[175px] tw-p-2 tw-text-center tw-border-gray-300 tw-font-semibold tw-flex tw-items-center tw-justify-center">
                <p>Hotel</p>
              </div>
            ) : (
              <div className=" tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-w-[175px] tw-p-2 tw-text-center tw-border-gray-300 tw-font-semibold tw-flex tw-items-center tw-justify-center">
                <p>{ue.description}</p>
              </div>
            )}
            {ue?.code === 'G' && (
              <div className=" tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-w-[100px] tw-p-2 tw-text-center tw-border-gray-300 tw-flex tw-items-center tw-justify-center">
                <p>{ue.mileage} miles</p>
              </div>
            )}

            <div className=" tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-w-[100px] tw-p-2 tw-text-center tw-border-gray-300 tw-flex tw-gap-2 tw-items-center tw-justify-center">
              <span className="tw-text-gray-400 tw-text-[19px]">
                <FaDollarSign />
              </span>
              <p>{ue?.amount}</p>
            </div>
            <div className="tw-border-t-[1px] tw-border-b-[1px] tw-border-l-[1px] tw-border-r-[1px] tw-p-2 tw-border-gray-300 tw-rounded tw-flex tw-gap-2 tw-items-center">
              <p>
                {' '}
                <span className="tw-text-red-500 tw-underline">
                  {!!ue?.receipts ? ue?.receipts?.length! : '0'}
                </span>{' '}
                Receipts
              </p>
            </div>
          </div>
        );
      })
    );
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <div className="tw-border-gray-300 tw-border-[1px] tw-rounded tw-flex tw-flex-col tw-justify-evenly">
          <p className="tw-text-center">{`${calendarDay?.dayName} ${calendarDay?.friendlyDate}`}</p>
          {!!compType && compType === 'D' && (
            <p className="tw-text-center">{`${
              dayEntry?.hours! / 8
            }` + `${(dayEntry?.hours! / 8) === 1 ? ` Day` : ` of the Day` }`}</p>
          )}
          {!!compType && compType !== 'D' && (
            <p className="tw-text-center">{`Hours: ${dayEntry?.hours!}`}</p>
          )}
        </div>

        <div className="tw-col-span-3 tw-flex tw-items-center tw-relative">
          <textarea
            style={{resize: 'none'}}
            name={`calendarDays.${calendarDayIndex}.dayEntries.${dayEntryIndex}.workDescription`}
            rows={3}
            ref={register}
            disabled={disableDayEntry}
            className={
              !!showValidation
                ? 'tw-w-full tw-h-full tw-border tw-border-red-400 tw-px-2 tw-py-1 tw-border-t-[1px] tw-rounded tw-border-l-[1px] tw-mr-8'
                : !!disableDayEntry
                ? 'tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-border-t-[1px] tw-rounded tw-border-l-[1px] tw-mr-8 tw-cursor-not-allowed'
                : 'tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-border-t-[1px] tw-rounded tw-border-l-[1px] tw-mr-8'
            }
            placeholder={'Enter your description'}
            onFocus={() => setShowValidation(false)}
          />
          {!!showDeleteBtn && !disableDayEntry && (
            <span
              className="tw-bg-red-500 tw-text-white tw-p-1 tw-rounded tw-absolute tw-text-[25px] tw-right-[5px] tw-top-0 tw-hover:tw-bg-red-800 tw-active:tw-bg-red-300 tw-cursor-pointer"
              onClick={() => displayDeleteWarning()}
            >
              {<FiDelete />}
            </span>
          )}
          {!!disableDayEntry && (
            <span
              className="tw-bg-gray-500 tw-text-white tw-p-1 tw-rounded tw-absolute tw-text-[25px] tw-right-[5px] tw-top-0 tw-hover:tw-bg-gray-800 tw-active:tw-bg-gray-300 tw-cursor-pointer"
              onClick={() => copyDescription()}
            >
              {<HiOutlineClipboardCopy />}
            </span>
          )}
        </div>
      </React.Fragment>

      <div className="tw-col-start-1 tw-col-span-3 tw-grid">
        <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1 tw-justify-around">
          {renderExpenses()}
        </div>
      </div>
      <div className="tw-col-span-4 mt-2">
        <div className="tw-grid tw-grid-cols-[200px_175px_175px_175px_175px_400px] tw-px-4 tw-pb-4">
          <div>
            <button
              className="tw-bg-green-500 tw-text-white tw-hover:tw-bg-green-600 tw-rounded tw-tw-w-full tw-p-[4px]"
              onClick={() => addExpense(`workExp-${calendarDay?.friendlyDate}`)}
            >
              Add Expense
            </button>
          </div>
          <div className="tw-col-start-2 tw-col-end-6">
            <p className="tw-w-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-border-t-[1px] tw-rounded tw-border-l-[1px] tw-p-[4px] tw-text-center">
              Expenses
            </p>
          </div>

          <div>
            <p className="tw-text-center tw-border-gray-300 tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-border-r-[1px] tw-p-[4px]">
              View/Edit Receipts
            </p>
          </div>
          <div className="tw-col-start-2 tw-col-end-6">
            <ExpenseTable
              entryIndex={`workExp-${calendarDay?.friendlyDate}`}
              indexSelected={indvBtn}
              calendarDayIndex={calendarDayIndex}
              dayEntryIndex={dayEntryIndex}
              addExpense={addUniqueExpense}
              dayEntry={dayEntry!}
              register={register}
              setValue={setValue}
              disableExpense={disableDayEntry}
              showContainer={handleShowContainer}
              expenseAdded={handleExpenseAdded}
              displayReceipts={handleDisplayReceipts}
              adminToUser={adminToUser}
              payperiod={payperiod}
            />
          </div>
          <div
            className={`tw-text-center tw-border-gray-300 tw-border-t-[1px] tw-rounded tw-border-b-[1px] tw-border-l-[1px] tw-border-r-[1px] tw-p-[4px] tw-flex tw-flex-col tw-items-center tw-w-full 
              ${!showContainer ? 'hidden' : ''}`}
          >
            <div className="tw-mt-4 tw-p-2 tw-mb-2">
              <p className="tw-text-red-400 tw-text-[23px] tw-underline tw-font-semibold">{`${
                !expense && !displayReceipts
                  ? ''
                  : expenseDescript === 'Motel'
                  ? 'Hotel'
                  : expenseDescript
              } Receipts`}</p>
            </div>
            <Button 
              type={'button'}
              text={'View all'}
              onClick={() => loadAndViewReceiptThumbnails()}
            />
            {!!displayReceipts &&
              !!expense?.receipts &&
              expense?.receipts!.length > 0 &&
              renderReceipts()}
            {!displayReceipts && <p>No Receipts uploaded</p>}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DayEntryComponent;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/DayEntryComponent.tsx